import { message, Modal, Select } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { findAllExamTemplates } from '../../../service/examTemplateService';
import { ExamTemplate } from '../../../model/response';

interface Props {
  isOpen: boolean;
  onCloseModal: () => void;
  onSave: (templateId: string) => void;
  subjectId: string | undefined;
}

export default function SelectExamTemplate({ isOpen, onCloseModal, onSave, subjectId }: Props) {
  const [examTemplates, setExamTemplates] = useState<ExamTemplate[]>([]);
  const [examTemplateId, setExamTemplateId] = useState<string | null | undefined>();

  useEffect(() => {
    findAllExamTemplates()
      .then((examTemplates) => {
        setExamTemplates(examTemplates);
      })
      .catch((error) => console.error(error));
  }, []);

  const onChangeSelect = (e: any) => {
    setExamTemplateId(e);
  };

  const onOk = async () => {
    try {
      if (examTemplateId) {
        onSave(examTemplateId);
      } else {
        message.error('Chọn mẫu đề thi.');
      }
    } catch (err) {}
  };

  const getListExamTemplate = useMemo(() => {
    return examTemplates.filter((item) => item.subject.id === subjectId);
  }, [subjectId, examTemplates]);

  useEffect(() => {}, [isOpen]);

  return (
    <Modal open={isOpen} onOk={onOk} onCancel={onCloseModal}>
      <div className="text-[18px]">Chọn mẫu đề thi tạo đề:</div>
      <div className="mt-2">
        <Select
          placeholder={'Mẫu đề thi'}
          onChange={(e) => onChangeSelect(e)}
          className="w-full"
          style={{ flex: 1 }}
          value={examTemplateId}
          options={
            getListExamTemplate
              ? getListExamTemplate.map((item) => ({
                  value: item.id,
                  label: item.name,
                }))
              : []
          }
        />
      </div>
    </Modal>
  );
}
